import React from "react";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";

const DesignAssetDescription = ({
  siteCreated,
  projectStatusData,
  checkAssetStatus,
  saveDraftComponentData,
  setIsOpen,
}) => {
  const  deploymentReady = sessionStorage.getItem("deploymentReady");
  const projectTypeValue = useProjectTypeValue();
 return  (
  <>
    <div className="row se-white-background sticky-button" style={{lineHeight:"14px"}}>
      <div className="col-sm-12">
      <div className="row text-center">
        {(projectStatusData?.projectStatus === "COMPLETED" ||
          projectStatusData?.projectStatus === "COMPLETED_AND_SEND") && (
          <div className="col-sm-12 mt-1 d-flex justify-content-center">
            <span className="se-error-message-note text-center">
              {`Change the project state to in-progress to update the project`}
            </span>
          </div>
        )}
        {(siteCreated && projectTypeValue !== "NMGaaS ETO") && (
          <div className="col-sm-12 mt-1 d-flex justify-content-center">
            <span className="se-error-message-note text-center">
              {`Site already created for the project, no more modifications allowed`}
            </span>
          </div>
        )}
      </div>
      </div>
      <div className="col-sm-12">
        <div className="row">
        <div className="col-sm-9 col-md-9 col-lg-9 col-xl-9 text-center se-sld-legendHeader">
          <div className="unconfigured">
            <div className="sld-legend d-flex align-items-center" role="alert">
              <span className="sld-legend-icon">
                <se-icon className="icon-large">
                  <span>electricity_polarity_negative_minus</span>
                </se-icon>
              </span>
              <span className="message">Unconfigured Asset</span>
            </div>
          </div>

          <div className="selected-asset">
            <div className="sld-legend d-flex align-items-center">
              <span className="sld-legend-icon">
                <se-icon className="icon-large" color="secondary">
                  <span>electricity_polarity_negative_minus</span>
                </se-icon>
              </span>
              <span className="message">Selected Asset</span>
            </div>
          </div>

          <div>
            <div className="sld-legend d-flex align-items-center">
              <span className="sld-legend-icon">
                <se-icon className="icon-large hydrated">
                  <span>electricity_polarity_negative_minus</span>
                </se-icon>
              </span>
              <span className="message">Configured Asset</span>
            </div>
          </div>
        </div>
        {
          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 text-right p-0 d-flex ">
            <se-button 
            option="flat" 
             color="primary"
             size = "small"
             icon = "body_eye"
              onClick={()=>{
                if(document.getElementsByTagName("se-container")[0]){
                   document.getElementsByTagName("se-container")[0].style.scrollbarWidth ="none";
                }
                setIsOpen(true);
                }}>View</se-button>
            <se-button
              disabled={
                deploymentReady ||
                projectStatusData?.projectStatus === "COMPLETED" ||
                projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
              }
              option="flat"
              onClick={saveDraftComponentData}
              color="primary"
              icon="action_save"
            >
              Save Changes
            </se-button>
          </div>
        }
      </div>
      </div>
    </div>
  </>
);
}
export default DesignAssetDescription;
